<template>
	<div class="sKeywordDet">
		<!-- 筛选 -->
		<filter-panel
			labelWidth="100px"
			:data="groups"
			:hideResult="true"
			@search="filterChange"
			@change="fileChange"
		></filter-panel>

		<div class="button-box">
			<div class="button-box_left">
				<el-button type="primary" :disabled="buttonDisabled" @click="addKeyword">添加</el-button>
				<el-button
					type="primary"
					:disabled="buttonDisabled"
					:loading="excludeLoading"
					@click="excludeKeyword"
					>排除</el-button
				>
				<el-button type="info" :disabled="buttonDisabled" @click="ignoreKeyword">忽略</el-button>
			</div>
			<div class="button-box_right">
				<el-button type="primary" :disabled="loading" :loading="taskLoading" @click="keywordRunTask"
					>AI判定当前页</el-button
				>
				<el-button type="primary" :loading="downloadLoading" @click="searchTermsDownload"
					>下载报告</el-button
				>
			</div>
		</div>

		<!-- 列表 -->
		<data-list
			ref="datalist"
			v-loading="loading"
			:data="data"
			:columns="column"
			:page="page"
			:page-size="page.pageSize"
			:selectable="selectable"
			:selection="true"
			:sort="sort"
			@sort-change="sortChange"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@selection-change="selectionChange"
		></data-list>

		<!-- 添加关键词弹窗 -->
		<addKeywordFormDialog
			ref="addKeywordFormDialogRef"
			title="添加关键词"
			dialogWidth="1200px"
		></addKeywordFormDialog>

		<!-- 排除关键词弹窗 -->
		<excludeKeywordFormDialog
			ref="excludeKeywordFormDialogRef"
			title="排除关键词"
			dialogWidth="1000px"
		></excludeKeywordFormDialog>

		<!-- 忽略关键词弹窗 -->
		<ignoreKeywordFormDialog
			ref="ignoreKeywordFormDialogRef"
			title="忽略关键词"
			dialogWidth="1000px"
		></ignoreKeywordFormDialog>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import addKeywordFormDialog from './components/addKeywordFormDialog.vue';
import excludeKeywordFormDialog from './components/excludeKeywordFormDialog.vue';
import ignoreKeywordFormDialog from './components/ignoreKeywordFormDialog.vue';

import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import { searchTermsType, searchTermsStatus } from '@/common/dictionary';
import filters from '@/mixins/filters.js';
import { getDateRegion, download2 } from '@/common/util.js';
import website from '@/backend/services/website/website.js';
import googleads from '@/backend/services/googleAds/googleAds.js';

const list = listPageCreate({
	searchConfig: {
		api: api.googleAds.searchList,
		method: 'POST',
		config: {
			timeout: 60000,
		},
	},
	getQuery(obj, that) {
		let { serviceId } = that.$route.query;
		return _.assign(obj, {
			serviceId,
		});
	},
});

export default {
	name: 'sKeywordDet',
	props: [],
	components: {
		filterPanel,
		addKeywordFormDialog,
		excludeKeywordFormDialog,
		ignoreKeywordFormDialog,
	},
	mixins: [list],
	data() {
		return {
			groups: {},
			column: [],
			startDate: '', // 开始日期保存
			endDate: '', // 结束日期保存
			taskLoading: false, // AI判定任务加载
			detectionTimer: null, // 轮询检测状态的定时器
			activeSelectData: [], // 多选数据
			excludeLoading: false, // 排除按钮加载状态
			downloadLoading: false, // 下载报告按钮加载状态
		};
	},
	computed: {
		buttonDisabled(self) {
			let { activeSelectData } = self;
			return activeSelectData.length === 0;
		},
	},
	watch: {},
	mounted() {
		this.page.pageSize = 40;
		this.sort = { sortName: 'IMPRESSIONS', sortType: 'desc' };
		this.setListConfig();
		this.advertisingSeries();
	},
	methods: {
		// 搜索词列表及筛选项配置
		setListConfig() {
			let date = getDateRegion('DAYS_7', 'YYYY-MM-DD', '&').split('&');
			// let date = ['2025-09-01', '2025-09-23'];
			this.startDate = date[0];
			this.endDate = date[1];

			this.groups = {
				others: [
					{
						tagName: 'sky-select',
						placeholder: '匹配类型',
						label: '匹配类型',
						defaultText: '匹配类型',
						options: searchTermsType,
						prop: 'searchTermMatchType',
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: '状态',
						label: '状态',
						defaultText: '状态',
						options: searchTermsStatus,
						prop: 'searchTermStatus',
						value: 4,
					},
					{
						tagName: 'sky-select',
						placeholder: '广告系列',
						label: '广告系列',
						defaultText: '广告系列',
						multiple: true,
						collapseTags: true,
						options: [],
						props: {
							label: 'campaignName',
							value: 'campaignId',
						},
						prop: 'campaignIdList',
						value: [],
					},
					{
						tagName: 'sky-select',
						placeholder: '广告组',
						defaultText: '广告组',
						label: '广告组',
						multiple: true,
						collapseTags: true,
						options: [],
						props: {
							label: 'adGroupName',
							value: 'adGroupId',
						},
						prop: 'adGroupIdList',
						value: [],
					},
					{
						tagName: 'sky-input',
						placeholder: '搜索词',
						label: '搜索词',
						prop: 'searchTermName',
						clearable: true,
						value: '',
					},
					{
						tagName: 'sky-date-picker',
						type: 'daterange',
						label: '时间范围',
						startPlaceholder: '开始时间',
						endPlaceholder: '结束时间',
						clearable: false,
						prop: ['startDate', 'endDate'],
						value: [date[0], date[1]],
						// value: ['2025-09-01', '2025-09-23'],
					},
					{
						tagName: 'sky-select',
						placeholder: '相关性',
						defaultText: '相关性',
						label: '相关性',
						options: [
							{
								label: '低',
								value: '1',
							},
							{
								label: '中',
								value: '2',
							},
							{
								label: '高',
								value: '3',
							},
						],
						prop: 'relevance',
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: '建议操作',
						defaultText: '建议操作',
						label: '建议操作',
						options: [
							{
								label: '添加',
								value: true,
							},
							{
								label: '排除',
								value: false,
							},
						],
						prop: 'isAdd',
						value: '',
					},
				],
			};
			this.column = [
				{
					label: '搜索词',
					type: 'tooltip',
					bind: 'searchTermName',
				},
				{
					label: '匹配类型',
					type: 'percentage',
					width: 180,
					bind: 'searchTermMatchType',
					showOverflowTooltip: true,
					content: '在Google上触发广告的搜索字词与您账号中实际关键字的相关程度',
					style: {
						overflow: 'hidden',
						'text-overflow': 'ellipsis',
						'white-space': 'nowrap',
					},
					dataStyle(val) {
						switch (val) {
							case '1':
								return '广泛匹配';
							case '2':
								return '完全匹配';
							case '3':
								return '精确匹配（紧密变体）';
							case '4':
								return '词组匹配（紧密变体）';
							case '5':
								return '词组匹配';
							case '8':
								return 'Ai Max';
							case '9':
								return 'Performance Max';
							default:
								return '-';
						}
					},
				},
				{
					label: '状态',
					type: 'textStatus',
					bind: 'searchTermStatus',
					content: '是否已经将当前搜索词作为关键字或否定关键字添加到账户中',
					width: 120,
					dataStyle(val) {
						switch (val) {
							case '1':
								return '已添加';
							case '2':
								return '已添加/已排除';
							case '3':
								return '已排除';
							case '4':
								return '未知';
							case '5':
								return '已忽略';
						}
					},
					statusSty(val) {
						switch (val) {
							case '1':
								return {
									color: '#3DA1FF',
								};
							case '2':
								return {
									color: '#FF9FA4',
								};
							case '3':
								return {
									color: '#4FD2AA',
								};
							case '4':
								return {
									color: '#999999',
								};
							case '5':
								return {
									color: '#4FD2AA',
								};
						}
					},
				},
				{
					label: '相关性',
					type: 'textStatus',
					bind: 'relevance',
					width: 70,
					dataStyle(val) {
						switch (val) {
							case '1':
								return '低';
							case '2':
								return '中';
							case '3':
								return '高';
							default:
								return '-';
						}
					},
					style(val) {
						switch (val) {
							case '1':
								return {
									color: '#67C23A',
								};
							case '2':
								return {
									color: '#E6A23C',
								};
							case '3':
								return {
									color: '#F56C6C',
								};
						}
					},
				},
				{
					label: '判断依据',
					bind: 'judgementBasis',
					showOverflowTooltip: true,
				},
				{
					label: '建议操作',
					bind: row => {
						let { isAdd } = row;
						if (isAdd === 'true') return '添加';
						if (isAdd === 'false') return '排除';
						return '-';
					},
					showOverflowTooltip: true,
				},
				{
					label: '消耗',
					type: 'percentage',
					bind: 'exchangeRateCost',
					showOverflowTooltip: true,
					width: 120,
					sort: 'COST',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
					dataStyle(val) {
						return filters.filters.rmb(val);
					},
				},
				{
					label: '展示次数',
					bind: 'impressions',
					width: 120,
					sort: 'IMPRESSIONS',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
				},
				{
					label: '点击次数',
					bind: 'clicks',
					width: 120,
					sort: 'CLICKS',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
				},
				{
					label: '点击率',
					type: 'percentage',
					bind: 'clicksRate',
					width: 120,
					sort: 'CTR',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
					dataStyle(val) {
						return filters.filters.jojint(val);
					},
				},
				{
					label: '点击均价',
					type: 'percentage',
					bind: 'clickAveragePrice',
					showOverflowTooltip: true,
					width: 120,
					sort: 'AVERAGE_CPC',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
					dataStyle(val) {
						return filters.filters.rmb(val);
					},
				},
				{
					label: '关键词',
					bind: 'keywordsName',
					showOverflowTooltip: true,
				},
				{
					label: '广告系列',
					bind: 'campaignName',
					showOverflowTooltip: true,
				},
				{
					label: '广告组',
					bind: 'adGroupName',
					showOverflowTooltip: true,
				},
			];
		},
		// 多选
		selectionChange(val) {
			this.activeSelectData = val;
		},
		// 多选筛选
		selectable(row) {
			let { searchTermStatus } = row;
			return searchTermStatus === '4';
		},
		// 筛选项变化
		fileChange(row, val) {
			if (row.label == '时间范围' && val.length !== 0) {
				this.startDate = val[0];
				this.endDate = val[1];
			}
			if (row.label == '广告系列' && val.length !== 0) {
				this.setAdGroupIdList(val);
			}
			if (row.label == '广告系列' && val.length === 0) {
				this.groups.others.forEach(item => {
					if (item.label === '广告组') {
						item.options = [];
					}
				});
			}
		},
		// 获取广告系列
		async advertisingSeries() {
			let { serviceId } = this.$route.query;
			let { startDate, endDate } = this;
			let res = await website.advertisingSeries({
				serviceId,
				startDate,
				endDate,
			});

			this.groups.others.forEach(item => {
				if (item.label === '广告系列') {
					item.options = res.data;
				}
			});
		},
		// 设置广告组
		async setAdGroupIdList(val) {
			let { serviceId } = this.$route.query;
			let { startDate, endDate } = this;
			let res = await website.advertisingGroup({
				campaignIdList: val,
				serviceId,
				startDate,
				endDate,
			});

			this.groups.others.forEach(item => {
				if (item.label === '广告组') {
					item.options = res.data;
				}
			});
		},
		// AI判定任务
		async keywordRunTask() {
			const { serviceId } = this.$route.query;

			// 设置加载状态
			this.taskLoading = true;
			this.loading = true;

			try {
				let { data } = this;

				// 数据过滤和处理（保留原有逻辑）
				let dataCopy = _.cloneDeep(data)
					.filter(item => {
						// 增加空值校验，避免属性不存在导致的错误
						if (!item || item.searchTermStatus === undefined) return false;
						return item.searchTermStatus === '4';
					})
					.map(item => {
						return {
							...item,
							serviceId,
						};
					});

				// 发起接口请求（增加超时控制）
				const res = await Promise.race([
					googleads.keywordRunTask({ searchKeywords: dataCopy }, serviceId),
					// 超时控制：10秒无响应则判定为超时
					new Promise((_, reject) => setTimeout(() => reject(new Error('接口请求超时')), 10000)),
				]);

				// 接口调用成功，启动轮询
				if (res.data) await this.keywordTaskData();
			} catch (error) {
				// 重置加载状态
				this.taskLoading = false;
				this.loading = false;
			}
		},
		// 获取AI判定任务结果（优化后：接口响应后再启动下一次轮询）
		async keywordTaskData() {
			// 清除可能存在的旧定时器（防止重复轮询）
			if (this.detectionTimer) {
				clearTimeout(this.detectionTimer);
				this.detectionTimer = null;
			}

			// 轮询核心函数（递归调用）
			const poll = async () => {
				try {
					const { serviceId } = this.$route.query;
					// 没有serviceId则终止轮询
					if (!serviceId) return;

					// 发起接口请求（等待接口响应）
					const res = await googleads.keywordTaskData(serviceId);
					const { status } = res.data;

					// 定义状态处理映射（保持原有逻辑）
					const statusHandlers = {
						2: () => {
							this.$message.success('检测已完成');
							this.taskLoading = false;
							setTimeout(() => {
								this.query();
							}, 5000);
						},
						3: () => {
							this.$message.error('检测失败');
							this.taskLoading = false;
							this.query();
						},
						default: () => {
							if (status !== 1) {
								this.$message.warning('未知检测状态');
								this.taskLoading = false;
								this.query();
							}
						},
					};

					// 执行状态处理
					const handler = statusHandlers[status] || statusHandlers.default;
					handler();

					// 只有状态为1（进行中）时，才继续下一次轮询
					if (status === 1) {
						// 接口响应后，等待1500ms再发起下一次请求
						this.detectionTimer = setTimeout(poll, 1500);
					}
				} catch (error) {
					console.error('轮询出错:', error);
					this.taskLoading = false;
					this.loading = false;
					// 出错后终止轮询（也可根据需求设置重试机制）
				}
			};

			// 启动第一次轮询
			poll();
		},
		// 添加关键词
		async addKeyword() {
			let { activeSelectData } = this;
			let { serviceId } = this.$route.query;
			let list = _.cloneDeep(activeSelectData).map(item => {
				return {
					...item,
					finalUrl: '',
					cpcBidMicros: 0,
				};
			});
			let { cancel } = await this.$refs.addKeywordFormDialogRef.show({
				list,
				serviceId,
			});
			if (!cancel) this.query();
		},
		// 排除关键词
		async excludeKeyword() {
			this.excludeLoading = true;

			let self = this;
			let { activeSelectData } = this;
			let { serviceId } = this.$route.query;
			let list = _.cloneDeep(activeSelectData);
			let { cancel } = await this.$refs.excludeKeywordFormDialogRef.show({
				list,
				serviceId,
				self,
			});
			if (!cancel) this.query();
		},
		// 忽略关键词
		async ignoreKeyword() {
			let { activeSelectData } = this;
			let { serviceId } = this.$route.query;
			let list = _.cloneDeep(activeSelectData);
			let { cancel } = await this.$refs.ignoreKeywordFormDialogRef.show({
				list,
				serviceId,
			});
			if (!cancel) this.query();
		},
		// 下载搜索词报告
		async searchTermsDownload() {
			this.downloadLoading = true;
			let { serviceId } = this.$route.query;
			let { sort, filterParams } = this;

			let params = Object.assign(
				{},
				{
					sortName: sort && sort.sortName ? sort.sortName : undefined,
					sortType: sort && sort.sortType ? sort.sortType : undefined,
					serviceId,
				},
				filterParams
			);

			let res = await website.searchTermsDownload(params);

			this.downloadLoading = false;

			if (!res.data) {
				this.$message.info('所选时间段暂无数据');
				return false;
			}

			download2(res.data, '搜索词报告.xlsx');
		},
	},
	// 组件卸载时清除定时器（防止内存泄漏）
	beforeUnmount() {
		if (this.detectionTimer) {
			clearTimeout(this.detectionTimer);
		}
	},
};
</script>

<style lang="scss" scoped>
.sKeywordDet {
	.button-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: #fff;
		margin: 10px 0 20px 0;
		padding: 20px 10px;
	}
}
</style>
